import React, { useState } from 'react';
import { X } from 'lucide-react';

interface EliminatedChoicesDisplayProps {
  eliminatedChoices: Record<string, string>;
  currentQuestionId: string | undefined;
  isOpen: boolean;
  onToggle: () => void;
}

export const EliminatedChoicesDisplay: React.FC<EliminatedChoicesDisplayProps> = React.memo(({
  eliminatedChoices,
  currentQuestionId,
  isOpen,
  onToggle
}) => {
  
  if (!currentQuestionId || !eliminatedChoices[currentQuestionId]) {
    return null;
  }

  const eliminated = eliminatedChoices[currentQuestionId];

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg p-4 
                    border border-gray-200 animate-in slide-in-from-bottom-5 duration-300 z-50">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-semibold text-gray-700">Elenenler</h4>
        <button
          onClick={onToggle}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Kapat"
        >
          <X className="w-4 h-4 text-gray-500" />
        </button>
      </div>
      <div className="flex gap-2">
        {eliminated.split('').map((choice) => (
          <div
            key={choice}
            className="w-8 h-8 rounded-full bg-red-100 border-2 border-red-400 
                     flex items-center justify-center font-semibold text-red-600
                     relative overflow-hidden"
          >
            <span className="relative z-10">{choice}</span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-10 h-0.5 bg-red-500 rotate-45 absolute"></div>
              <div className="w-10 h-0.5 bg-red-500 -rotate-45 absolute"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

EliminatedChoicesDisplay.displayName = 'EliminatedChoicesDisplay';

export default EliminatedChoicesDisplay;